export class Boxes {
    content: string;
    weight: number = 0;
    excWeight: number = 0;
    calWeight: number = 0;
    length: number = 0;
    width: number = 0;
    height: number = 0;
    shipmentId: number;
    packTypeId: number;
    boxTypeId: number;
    structureId: number;
    totalBox: number = 0;
    price: number = 0;
    totalPrice: number = 0;
    isAllowPrice: boolean = false;
    id: number;
    code: string;
    name: string;
    woodWeight: number = 0;
}